export default __webpack_public_path__ + "images/default-user-profile.d9e2b750d88bb1818d0386e244a467d4.jpg";